import { any } from 'ramda';
import { Component, AfterContentInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { SectionFormDirective } from '@app/classes/section-form.class';
import { isApplyForBenefits, isChangeReport, isExported, isOtherModes, isPresumptiveApp, isPresumptiveBcc} from '@app/helpers/mode.helpers';
import { Individual } from '@app/models/individual.model';
import { ModalService } from '@app/services/modal/modal.service';
import Vs from "@app/services/validators/validators.service";
import { distinctUntilChanged } from "rxjs/operators";
import { formatDate } from '@angular/common';
import { formatTableData } from '@app/helpers/tables.helpers';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from '@app/services/application/application.service';
import { Title } from '@angular/platform-browser';

export const getIndividualTable = (individuals = []) => {
  return individuals.map((individual: Individual) => ({
    code: individual.identifier,
    value: `${individual.name.fullName}, ${individual.age} ${individual.gender.code}`
  }));
}
@Component({
    templateUrl: './other-benefits.component.html',
    styleUrls: ['./other-benefits.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class OtherBenefitsComponent extends SectionFormDirective implements AfterContentInit {
  today = new Date();
  isExported: any = null;
  individualTable = [];
  appType = sessionStorage.getItem('appType');
  isKepro = false;
  isRenewBenefits = false;
  codeYes = { code: 'Y', spValue : 'Si', value: 'Yes' };
  codeNo = { code: 'N', spValue : 'No', value: 'No' };
  medicalBillsIndividualTable = [];
  bccIndividualTable = [];
  medicareIndSwToolTip = 'Medicare is the federal health insurance for people age 65 or older and certain people with disabilities.  If anyone in your household has Medicare, TennCare may help pay for the Medicare premiums (monthly payment) and/or co-pays and deductibles (your part of the doctor bills).  Some Medicare cost sharing programs are QMB (Qualified Medicare Beneficiary), SLMB (Specified Low Income Medicare Beneficiary), and QI1.  Each program pays some of your Medicare costs and has different limits for income and resources.';
  brstCervCancerSwToolTip = 'You must apply at the health department first if you need treatment for breast or cervical cancer.';
  medicalBillSwToolTip = 'You can use medical bills for anyone in your household.  These bills can be for care you or people in your home received this month (your application month) or for the last 3 months.  You can also use medical bills that you\'ve paid this month no matter how old the bills are.';
  hcbsSwToolTip = 'Home and Community Based Services are for individuals who would qualify for the level of care provided in a nursing home but want services in their home or the community instead.';
  ecfToolTip = `Employment and Community First CHOICES is for people of all ages who have an intellectual or developmental disability (I/DD). This includes people who have significant disabilities. Services help people with I/DD gain as much independence as possible. It can even help you explore the possibility of working by helping you learn skills for work, finding and keeping a job. People are supported to live with their family or in the community, not in an institution. Residential services are available for adults with I/DD who do not live with family but need supports where they live. To see if you can be served through this program, you must complete a self-referral form. We’ll tell you how to do that later on in this application.`
  isAFB;
  isPPFRM;
  isPresumptive;
  isPresumptiveBcc;
  isExpensesDisabled = false;
  isResoursesDisabled = false;
  isMedicalBillsDisabled = false;
  isCheckboxDisabled = false;
  minimumDate = new Date("1900-01-01T00:00:00.000-06:00");
  userType = sessionStorage.getItem('userType');
  translatedLang;
  defaultLanguage;
  isFullCoverageApp;
  kbValue;
  isFinReassessment = false;
  showKb = true;
  disableKb = false;
  changeMode;
  isMedicalBillSw = false;
  medicalBillsIndvs = [];
  scheduledModules = [];
  enableExpensesSection;
  enableResourcesSection;
  brstCervCancerReadonlyControls: string[] = [];
  isTransferDisabled = false;
  isBrstCervCancerDisabled = false;
  enableTransferSection;
  isEbmsDriverFlow = JSON.parse(sessionStorage.getItem("embsDriverFlow"));
  isPreterm = sessionStorage.getItem('isPreterm') === "PRETERM" && (sessionStorage.getItem('appType') === 'RB' || (sessionStorage.getItem('appType') === 'REDETERMINATION'  && sessionStorage.getItem('isKepro') === "true"));

  constructor(
    private modalService: ModalService,
    builder: FormBuilder,
    public translateService: TranslateService,
    private application: ApplicationService,
    private titleService: Title
  ) {
    super(builder);
    this.titleService.setTitle('Other Health Care Questions');
  }

  get otherBenefitsIndvProfileData(): FormArray {
    return this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
  }

  getindividualsById(id: string): string {
    const individulal = this.individuals.find((item) => item.identifier === id);
    return individulal ? individulal.name.fullName : '';
  }


  isInvalidName(event,row) {
    const enteredName = event?.target?.value;
    if (event && (!enteredName || enteredName === '' || enteredName === 'Invalid date')) {
      event.target.value = enteredName;
      if (event.target.name === 'hospitalName') {
        row.controls.hospitalName.setValidators([Vs.required, Vs.unit, Vs.maxLength(20)]);
        row.controls.hospitalName.updateValueAndValidity();
      } if (event.target.name === 'nursingHomeName') {
        row.controls.nursingHomeName.setValidators([Vs.required, Vs.unit, Vs.maxLength(20)]);
        row.controls.nursingHomeName.updateValueAndValidity();
      }
    }
  }
  isInvalidDate(event, i,row) {
    const individual = this.individuals.find((item) => item.identifier === row.value.indvId);
    const enteredDate = event?.target?.value || event;
    if ( event && (!enteredDate || enteredDate === '' || enteredDate === 'Invalid date')) {
      event.target.value = enteredDate;
      if (event?.target?.name === 'medFacilityAdmitDt') {
        row.controls.medFacilityAdmitDt.setValidators([Vs.required, Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate]);
        row.controls.medFacilityAdmitDt.updateValueAndValidity();
      } if (event?.target?.name === 'nursingHomeAdmitDt') {
        row.controls.nursingHomeAdmitDt.setValidators([Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate]);
        row.controls.nursingHomeAdmitDt.updateValueAndValidity();
      }
    } else if (event?.target?.name === 'medFacilityAdmitDt') {
      row.controls.medFacilityAdmitDt.setValidators([Vs.required, Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate]);
      row.controls.medFacilityAdmitDt.updateValueAndValidity();
      event.target.value = formatDate(this.otherBenefitsIndvProfileData.controls[i].value.medFacilityAdmitDt, 'MM/dd/yyyy', 'en');
      const indvDob = individual.birthDate;
      const enteredDate = event.target.value;
      const d1 = new Date(indvDob);
      const d2 = new Date(enteredDate);
      if (d1 && d2 && d2 < d1 && d2 > this.minimumDate ) {
        row.controls.medFacilityAdmitDt.setErrors({ INVALID_DOB: true });
        this.formGroup.updateValueAndValidity();
      }
    } else if (event?.target?.name === 'nursingHomeAdmitDt') {
      row.controls.nursingHomeAdmitDt.setValidators([ Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate]);
      row.controls.nursingHomeAdmitDt.updateValueAndValidity();
      event.target.value = formatDate(this.otherBenefitsIndvProfileData.controls[i].value.nursingHomeAdmitDt, 'MM/dd/yyyy', 'en');
      const indvDob = individual.birthDate;
      const enteredDate = event.target.value;
      const d1 = new Date(indvDob);
      const d2 = new Date(enteredDate);
      if (d1 && d2 && d2 < d1 && d2 > this.minimumDate ) {
        row.controls.nursingHomeAdmitDt.setErrors({ INVALID_DOB: true });
        this.formGroup.updateValueAndValidity();
      }
    }
  }

  getCtrl(param) {
    let targetCtrl;
    this.otherBenefitsIndvProfileData.controls.forEach((profileFormGroup: FormGroup) => {
      targetCtrl = this.getControl(param, profileFormGroup)?.valid;
    })
    return targetCtrl;
  }

  languageCheck(language) {
    this.tables = language === 'sp' ? formatTableData(this.tables, 'spDescription') : formatTableData(this.tables, 'description');
  }

  tableCodeValue (tableName, tableControl) {
    return this.getTableCodeValues(tableName, tableControl, this.translatedLang)
  }

  getExpensesOrResoursesSwitch(scheduledArray) {
    const expensesArray = scheduledArray.find(item => item.moduleId === 'XPPPG');
    const resoursesArray = scheduledArray.find(item => item.moduleId === 'ASPPG');
    const transferArray = scheduledArray.find(item => item.moduleId === 'TRPPG');
    const expensesSection = expensesArray?.sections[0];
    const resoursesSection = resoursesArray?.sections[0];
    const transferSection = transferArray?.sections[0];

    if (expensesSection?.changeRequested === true) {
      this.enableExpensesSection = true;
    }
    if (resoursesSection?.changeRequested === true) {
      this.enableResourcesSection = true;
    }
    if (transferSection?.changeRequested === true) {
      this.enableTransferSection = true;
    }

    if (this.changeMode) {
      if (this.enableExpensesSection) {
        const expensesInd = this.getControl('data.expensesInd');
        expensesInd.enable();
        expensesInd.patchValue({ code: "Y", value: "Yes" }) 
      }
      if (this.enableResourcesSection) {
        const assetInd = this.getControl('data.assetInd');
        assetInd.enable();
        assetInd.patchValue({ code: "Y", value: "Yes" })
      }
      if (this.enableTransferSection) {
        const transferredResInd = this.getControl('data.transferredResInd');
        transferredResInd.enable();
        transferredResInd.patchValue({ code: "Y", value: "Yes" })
      }
    }
  }

  ngAfterContentInit() {
    this.changeMode = isChangeReport(this.mode);
    if (this.changeMode) {
      this.application.getSection(this.applicationNumber, 'SURCH').subscribe(rtn => {
        if (rtn) {
          this.scheduledModules = rtn.records[0].data.modules;
          this.getExpensesOrResoursesSwitch(this.scheduledModules)
        }
      })
    }
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.languageCheck(this.defaultLanguage);
    this.disableKb = JSON.parse(sessionStorage.getItem('disableKb'));

    this.translateService.onDefaultLangChange.subscribe((res) => {
    this.translatedLang = res.lang;
    this.languageCheck(res.lang);
    });
    this.isAFB = isApplyForBenefits(this.applicationType);
    this.isPresumptive = isPresumptiveApp(this.applicationType);
    this.isPresumptiveBcc = isPresumptiveBcc(this.applicationType);
    this.isRenewBenefits = (this.appType === 'RB'|| this.appType === "REDETERMINATION");
    this.isFinReassessment = JSON.parse(sessionStorage.getItem('isReassessment'));
    this.isFullCoverageApp = (this.isAFB && this.userType === 'RP') ? true : false;
    this.isKepro = sessionStorage.getItem('isKepro') === 'true';
    this.isPPFRM = (this.isFinReassessment && this.userType === 'RP');

    if (this.isFinReassessment || this.isFullCoverageApp) {
      const kbFlag = sessionStorage.getItem('isKbEligible');
      if (kbFlag === 'true') {
        this.showKb = true;
      } else {
        this.showKb = false;
      }
    };

    this.individualTable = getIndividualTable(this.individuals);
    if(this.appType==='BCC') {
      this.bccIndividualTable = getIndividualTable(this.individualsForBcc.filter(indv => indv.applyForCoverage.code === 'Y' || indv.applyForOnGoingCoverage.code === 'Y'));      
      this.presetBrstCervCancerFromApplyForCoverage();
    } else {
      this.bccIndividualTable = getIndividualTable(this.individuals);
    }
    
    const helpers = this.getControl('extras.helpers');

    const medicalBillsIndOpt = helpers.get('medicalBillsIndOpt');
    const brstCervCancerSwOpt = helpers.get('brstCervCancerSwOpt');
    const medFacilitySwOpt = helpers.get('medFacilitySwOpt');
    const nursingHomeSwOpt = helpers.get('nursingHomeSwOpt');
    const hospiceSwOpt = helpers.get('hospiceSwOpt');
    const hcbsSwOpt = helpers.get('hcbsSwOpt');
    const intelDisbSwOpt = helpers.get('intelDisbSwOpt');
    const medicareIndSwOpt = helpers.get('medicareIndSwOpt');
    const expensesIndOpt = helpers.get('expensesIndOpt');
    const assetIndSwOpt = helpers.get('assetIndSwOpt');
    const expenseDisableSw = this.getControl('data.expenseDisableSw')
    const assetDisableSw = this.getControl('data.assetDisableSw')
    const medBillsDisableSw = this.getControl('data.medBillsDisableSw')
    const ecfIndOpt = helpers.get('ecfIndSwOpt')
    const medBillSwOpt = this.getControl('data.medicalBillSw')
    const kbReferralSw = this.getControl('data.kbReferralSw')
    const ssiBenefitsSwOpt = helpers.get('ssiBenefitsSwOpt');
    const expensesInd = this.getControl('data.expensesInd')
    const assetInd = this.getControl('data.assetInd');
    const transferredResInd = this.getControl('data.transferredResInd');
    const transferAssetDisableSw = this.getControl('data.transferAssetDisableSw');
    const transferIndOpt = helpers.get('transferIndOpt');

    if (this.disableKb) {
      kbReferralSw.setValue({ code: 'Y', value: 'Yes', spValue: 'Si' });
    }

    // if (!this.isAFB || (this.userType === 'RP' && !this.isAFB)) {
    //   this.getControl('data.transferredResInd')?.setValue(null);
    //   this.getControl('data.transferredResInd')?.clearValidators();
    //   this.getControl('data.transferredResInd')?.updateValueAndValidity();
    // }

    
    medicalBillsIndOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'medicalBillsIndSw'));
    brstCervCancerSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'brstCervCancerSw'));
    medFacilitySwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'medFacilitySw'));
    nursingHomeSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'nursingHomeSw'));
    hospiceSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'hospiceSw'));
    hcbsSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'hcbsSw'));
    intelDisbSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'intelDisbSw'));
    medicareIndSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'medicareIndSw'));
    expensesIndOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'expensesIndSw'));
    assetIndSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'assetIndSw'));
    ecfIndOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'ecfSw'));
    medBillSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'medicalBillSw'));
    ssiBenefitsSwOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'ssiBenefitsSw'));
    transferIndOpt.valueChanges.subscribe((changes) => this.updateProfileData(changes, 'transferredResIndSw'));

    this.isProfileOpted('medicareIndSw')
    this.isProfileOpted('brstCervCancerSw')
    if (this.appType === 'BCC') {
      this.getControl('extras.helpers.brstCervCancerSw').patchValue({ code: 'Y', value: 'Yes', spValue: 'Si' });
      this.isBrstCervCancerDisabled = true;
    }
    this.isProfileOpted('medFacilitySw')
    this.isProfileOpted('nursingHomeSw')
    this.isProfileOpted('hospiceSw')
    this.isProfileOpted('hcbsSw')
    this.isProfileOpted('intelDisbSw')
    this.isProfileOpted('medicalBillsIndSw')
    this.isProfileOpted('expensesIndSw')
    this.isProfileOpted('assetIndSw')
    this.isProfileOpted('ecfSw')
    this.isProfileOpted('ssiBenefitsSw')
    this.isProfileOpted('transferredResIndSw')

    medFacilitySwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const indivId = profileFormGroup.value.indvId
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if(res[indivId] === null && value === null){
              this.getControl('hospitalName', profileFormGroup).setValue(null);
              this.getControl('hospitalName', profileFormGroup).clearValidators();
              this.getControl('hospitalName', profileFormGroup).updateValueAndValidity();
              this.getControl('medFacilityAdmitDt', profileFormGroup).setValue(null);
              this.getControl('medFacilityAdmitDt', profileFormGroup).clearValidators();
              this.getControl('medFacilityAdmitDt', profileFormGroup).updateValueAndValidity();
              this.getControl('medFacilityAdmitDt', profileFormGroup).setErrors(null);
            }
            if (value) {
              Object.values(value).map(indiv => {
                if (indiv === indivId) {
                  const individual = this.individuals.find((item) => item.identifier === indivId);
                  const indvDob = individual.birthDate;
                  const AdmitDate = profileFormGroup.value.medFacilityAdmitDt;
                  const d1 = new Date(indvDob);
                  const d2 = new Date(AdmitDate);
                  this.getControl('minAdmitDate', profileFormGroup).patchValue(new Date(indvDob?.replace(/-/g, '\/')));
                  this.getControl('minAdmitDate', profileFormGroup).updateValueAndValidity();
                  this.getControl('hospitalName', profileFormGroup).setValidators([Vs.required, Vs.unit, Vs.maxLength(20)])
                  this.getControl('hospitalName', profileFormGroup).updateValueAndValidity();
                  this.getControl('medFacilityAdmitDt', profileFormGroup).setValidators([Vs.required, Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate])
                  this.getControl('medFacilityAdmitDt', profileFormGroup).updateValueAndValidity();
                  if (AdmitDate && d2 && d1 && d2 < d1 && d2 > this.minimumDate) {
                    this.getControl('medFacilityAdmitDt', profileFormGroup).setErrors({ INVALID_DOB: true });
                    this.formGroup.updateValueAndValidity();
                    }
                } else {
                  this.getControl('medFacilitySw', profileFormGroup).clearValidators();
                  this.getControl('medFacilitySw', profileFormGroup).updateValueAndValidity();
                }
              })
            } else if (res && value === null && show.length === 0) {
              this.getControl('medFacilitySw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('medFacilitySw', profileFormGroup).updateValueAndValidity();
              this.getControl('hospitalName', profileFormGroup).clearValidators();
              this.getControl('hospitalName', profileFormGroup).updateValueAndValidity();
              this.getControl('medFacilityAdmitDt', profileFormGroup).clearValidators();
              this.getControl('medFacilityAdmitDt', profileFormGroup).updateValueAndValidity();
              this.getControl('medFacilityAdmitDt', profileFormGroup).setErrors(null);
            }
          })
        });
      })

      nursingHomeSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const indivId = profileFormGroup.value.indvId
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if(res[indivId] === null && value === null){
              this.getControl('nursingHomeName', profileFormGroup).setValue(null);
              this.getControl('nursingHomeName', profileFormGroup).clearValidators();
              this.getControl('nursingHomeName', profileFormGroup).updateValueAndValidity();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).setValue(null);
              this.getControl('nursingHomeAdmitDt', profileFormGroup).clearValidators();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).updateValueAndValidity();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).setErrors(null);
            }
            if (value) {
              Object.values(value).map(indiv => {
                if (indiv === indivId) {
                  const individual = this.individuals.find((item) => item.identifier === indivId);
                  const indvDob = individual.birthDate;
                  const AdmitDate = profileFormGroup.value.nursingHomeAdmitDt;
                  const d1 = new Date(indvDob);
                  const d2 = new Date(AdmitDate);
                  this.getControl('minAdmitDate', profileFormGroup).patchValue(new Date(indvDob?.replace(/-/g, '\/')));
                  this.getControl('minAdmitDate', profileFormGroup).updateValueAndValidity();
                  this.getControl('nursingHomeName', profileFormGroup).setValidators([Vs.required, Vs.invalidNursingName])
                  this.getControl('nursingHomeName', profileFormGroup).updateValueAndValidity();
                  this.getControl('nursingHomeAdmitDt', profileFormGroup).setValidators([ Vs.notBefore120Years, Vs.validDate, Vs.maxFutureDate])
                  this.getControl('nursingHomeAdmitDt', profileFormGroup).updateValueAndValidity();
                  if (AdmitDate && d2 && d1 && d2 < d1 && d2 > this.minimumDate) {
                    this.getControl('nursingHomeAdmitDt', profileFormGroup).setErrors({ INVALID_DOB: true });
                    this.formGroup.updateValueAndValidity();
                    }
                } else {
                  this.getControl('nursingHomeSw', profileFormGroup).clearValidators();
                  this.getControl('nursingHomeSw', profileFormGroup).updateValueAndValidity();
                }
              })
            } else if (res && value === null && show.length === 0) {
              this.getControl('nursingHomeSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('nursingHomeSw', profileFormGroup).updateValueAndValidity();
              this.getControl('nursingHomeName', profileFormGroup).clearValidators();
              this.getControl('nursingHomeName', profileFormGroup).updateValueAndValidity();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).clearValidators();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).updateValueAndValidity();
              this.getControl('nursingHomeAdmitDt', profileFormGroup).setErrors(null);
            }
          })
        });
      })

      hospiceSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('hospiceSw', profileFormGroup).clearValidators();
                  this.getControl('hospiceSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('hospiceSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('hospiceSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      medicalBillsIndOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
              this.getControl('medicalBillsIndSw', profileFormGroup).clearValidators();
              this.getControl('medicalBillsIndSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('medicalBillsIndSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('medicalBillsIndSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      hcbsSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('hcbsSw', profileFormGroup).clearValidators();
                  this.getControl('hcbsSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('hcbsSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('hcbsSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      ecfIndOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('ecfSw', profileFormGroup).clearValidators();
                  this.getControl('ecfSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('ecfSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('ecfSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      intelDisbSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('intelDisbSw', profileFormGroup).clearValidators();
                  this.getControl('intelDisbSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('intelDisbSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('intelDisbSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      medicareIndSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
              this.getControl('medicareIndSw', profileFormGroup).clearValidators();
              this.getControl('medicareIndSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('medicareIndSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('medicareIndSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })


      ssiBenefitsSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
              this.getControl('ssiBenefitsSw', profileFormGroup).clearValidators();
              this.getControl('ssiBenefitsSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('ssiBenefitsSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('ssiBenefitsSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      brstCervCancerSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('brstCervCancerSw', profileFormGroup).clearValidators();
                  this.getControl('brstCervCancerSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('brstCervCancerSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('brstCervCancerSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      medBillSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          if (res) {
            Object.values(res).map(value => {
              if (value !== null) {
                show.push(value);
              }
              if (value) {
                this.getControl('medicalBillSw', profileFormGroup)?.clearValidators();
                this.getControl('medicalBillSw', profileFormGroup)?.updateValueAndValidity();
              } else if (res && value === null && show.length === 0) {
                this.getControl('medicalBillSw', profileFormGroup)?.setValidators([Vs.requiredTrue])
                this.getControl('medicalBillSw', profileFormGroup)?.updateValueAndValidity();
              }
            })
          }
        });
      })

      expensesIndOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          if (res) {
            Object.values(res).map(value => {
              if (value !== null) {
                show.push(value);
              }
              if (value) {
                this.getControl('expensesIndSw', profileFormGroup).clearValidators();
                this.getControl('expensesIndSw', profileFormGroup).updateValueAndValidity();
              } else if (res && value === null && show.length === 0) {
                this.getControl('expensesIndSw', profileFormGroup).setValidators([Vs.requiredTrue])
                this.getControl('expensesIndSw', profileFormGroup).updateValueAndValidity();
              }
            })
          }
        });
      })

      assetIndSwOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
                  this.getControl('assetIndSw', profileFormGroup).clearValidators();
                  this.getControl('assetIndSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('assetIndSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('assetIndSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

      transferIndOpt.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((res) => {
        const otherBenefitsIndvProfileCtrls = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
        otherBenefitsIndvProfileCtrls.controls.forEach((profileFormGroup: FormGroup) => {
          const show = [];
          Object.values(res).map(value => {
            if (value !== null) {
              show.push(value);
            }
            if (value) {
              this.getControl('transferredResIndSw', profileFormGroup).clearValidators();
              this.getControl('transferredResIndSw', profileFormGroup).updateValueAndValidity();
            } else if (res && value === null && show.length === 0) {
              this.getControl('transferredResIndSw', profileFormGroup).setValidators([Vs.requiredTrue])
              this.getControl('transferredResIndSw', profileFormGroup).updateValueAndValidity();
            }
          })
        });
      })

    const otherBenefitsIndvProfileData = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
    otherBenefitsIndvProfileData.controls.forEach((profileFormGroup: FormGroup) => {
      const medFacilityAdmitDt = this.getControl('medFacilityAdmitDt', profileFormGroup);
      medFacilityAdmitDt.setValidators([Vs.maxFutureDate]);
      medFacilityAdmitDt.updateValueAndValidity();
      const nursingHomeAdmitDt = this.getControl('nursingHomeAdmitDt', profileFormGroup);
      nursingHomeAdmitDt.setValidators([Vs.maxFutureDate]);
      nursingHomeAdmitDt.updateValueAndValidity();
    });

    if (this.isPresumptive) {
    this.today = null;
    }
    if (expenseDisableSw?.value?.code === 'Y' && this.isRenewBenefits) {
      this.isExpensesDisabled = true;
      this.getControl('extras.helpers.expensesIndSw').patchValue({code: "Y", value: "Yes",spValue: "Si"});
    }

    if (assetDisableSw?.value?.code === 'Y' && this.isRenewBenefits) {
      this.isResoursesDisabled = true;
      this.getControl('extras.helpers.assetIndSw').patchValue({code: "Y", value: "Yes",spValue: "Si"});
    }

    if (transferAssetDisableSw?.value?.code === 'Y' && this.isRenewBenefits) {
      this.isTransferDisabled = true;
      this.getControl('extras.helpers.transferredResIndSw').patchValue({code: "Y", value: "Yes",spValue: "Si"});
    }

    if (medBillsDisableSw?.value?.code === 'Y' && (this.isRenewBenefits || this.changeMode)) {
      this.isMedicalBillsDisabled = true;
    }

    if (medBillsDisableSw?.value?.code === 'Y' && this.isRenewBenefits) {
      this.isCheckboxDisabled = true;
    }



    if (
      isOtherModes(this.mode) &&
      this.record &&
      isExported(this.record.exportingStatus) &&
      this.record.data &&
      this.record.data.benefitAppliedFor
    ) {
      this.isExported = true;
    }

    if (this.changeMode) {
        const newlyAddedIndivs = this.individuals.filter(indv => indv.someoneMovedIn === 'Y');
        if (newlyAddedIndivs.length === 0) {
          medBillSwOpt.disable();
          expensesInd.disable();
          assetInd.disable();
          assetDisableSw.disable();
          expenseDisableSw.disable();
          medBillsDisableSw.disable();
          transferAssetDisableSw.disable();
          transferredResInd.disable();
        }
        this.isMedicalBillSw = newlyAddedIndivs.length && medBillsDisableSw.value?.code === 'Y' || newlyAddedIndivs.some(indiv => indiv.age < 21 || indiv.pregnant);
        if (this.isMedicalBillSw) {
          this.medicalBillsIndvs = getIndividualTable(this.individuals.filter(indv => indv.someoneMovedIn === 'Y' && (indv.age < 21 || indv.pregnant)));
        }
    } else {
      this.isMedicalBillSw = medBillsDisableSw.value?.code === 'Y' || this.individuals.some(indiv => indiv.age < 21 || indiv.pregnant);
      if(this.isRenewBenefits && medBillsDisableSw.value?.code === 'Y'){ 
        this.medicalBillsIndividualTable = getIndividualTable(this.individuals);
      }
      else if(this.isPresumptive)
      {      
        this.isMedicalBillSw = medBillsDisableSw.value?.code === 'Y' || this.individualsForMedicalBills.some(indiv => indiv.applyForOnGoingCoverage.code === 'Y' && (indiv.age < 21 || indiv.pregnant));        
        this.medicalBillsIndividualTable = getIndividualTable(this.individualsForMedicalBills.filter(item => item.applyForOnGoingCoverage.code === 'Y' && (item.age < 21 || item.pregnant) ));        
      }
      else if(this.isMedicalBillSw){
        this.medicalBillsIndividualTable = getIndividualTable(this.individuals.filter(item => (item.age < 21 || item.pregnant) ));
      }
      if(this.isPresumptiveBcc){
        this.bccIndividualTable = getIndividualTable(this.individualsForBcc.filter(indv => indv.applyForCoverage.code === 'Y' || indv.applyForOnGoingCoverage.code === 'Y'));
      }
    }

    var anyOptionSelectedOnLoad = this.anyDrivingQuestionAnsweredForTransfer();
    if (!anyOptionSelectedOnLoad && !this.isRenewBenefits) {
      this.getControl('data.transferredResInd')?.clearValidators();
      this.getControl('data.transferredResInd')?.updateValueAndValidity();
      this.getControl('extras.helpers.transferredResIndSw')?.clearValidators();
      this.getControl('extras.helpers.transferredResIndSw')?.updateValueAndValidity();
    }

    if (!this.isPresumptive) {
      this.getControl('data.transferredResIndSw')?.clearValidators();
      this.getControl('data.transferredResIndSw')?.updateValueAndValidity();
      this.getControl('extras.helpers.transferredResIndSw')?.clearValidators();
      this.getControl('extras.helpers.transferredResIndSw')?.updateValueAndValidity();
    }

    if (this.isPresumptive) {
      this.getControl('data.transferredResInd')?.clearValidators();
      this.getControl('data.transferredResInd')?.updateValueAndValidity();
    }

    var anyOptionSelectedRmbOnLoad = this.showTransferResources();
    if (!anyOptionSelectedRmbOnLoad && this.isRenewBenefits) {
      this.getControl('data.transferredResInd')?.clearValidators();
      this.getControl('data.transferredResInd')?.updateValueAndValidity();
      this.getControl('data.transferredResIndSw')?.clearValidators();
      this.getControl('data.transferredResIndSw')?.updateValueAndValidity();
      this.getControl('extras.helpers.transferredResIndSw')?.clearValidators();
      this.getControl('extras.helpers.transferredResIndSw')?.updateValueAndValidity();
    }

    if (anyOptionSelectedRmbOnLoad && this.isRenewBenefits) {
      this.getControl('data.transferredResInd')?.setValidators(Vs.required);
      this.getControl('data.transferredResInd')?.updateValueAndValidity();
    }
    this.brstCervCancerReadonlyControls = this.getPreSelectedControls(
      'extras.helpers.brstCervCancerSwOpt',
      this.bccIndividualTable
    );
    if(this.isEbmsDriverFlow) {
    const nonMedBillsIndivs = this.getValue('extras.helpers.nonMedBillsIndivs')
    const nonMedBillsIndivIds = nonMedBillsIndivs.map(item => item.code)

    this.otherBenefitsIndvProfileData.controls.forEach((group: FormGroup) => {
      const indivId = group.get('indvId')?.value;
      const medicalBillsIndSw = group.get('medicalBillsIndSw')?.value;
      if(nonMedBillsIndivIds.includes(indivId) && medicalBillsIndSw?.code === 'Y') {
        group.get('medicalBillsIndSw')?.setValue({
          code: 'N',
          spValue: 'No',
          value: 'No'
        })
      }
    })
  }
  }
  private getPreSelectedControls(
    path: string,
    applyForCoverageTable: { code: string; value: string }[] = []
  ): string[] {
    const group = this.getControl(path) as FormGroup;
    if (!group) return [];
    const applyForCoverageCodes = applyForCoverageTable
      .filter(item =>
        (this.individualsForBcc || []).some(
          indv => indv.identifier === item.code && indv?.applyForCoverage?.code === 'Y'
        )
      )
      .map(item => item.code);
    return [...new Set([...applyForCoverageCodes])];
  }

  ngAfterViewInit(): void {
    window.scroll(0,0);
    setTimeout(() => {
      const heading = document.querySelector('h1.page-title-h1') as HTMLElement;
      if (heading) { heading.style.outline = 'none'; heading.focus(); }
    }, 100);
  }

  updateProfileData(changes, fieldName) {
    const otherBenefitsIndvProfileData = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
    if (changes !== null) {
      const result = Object.values(changes).every(o => o === null);
      if (result === true) setTimeout(() => otherBenefitsIndvProfileData.setErrors({required: true}, {emitEvent: false}))
    };

    otherBenefitsIndvProfileData.controls.forEach((profileFormGroup: FormGroup) => {
      const individual = this.getValue('indvId', profileFormGroup);
      if (changes !== null && changes[individual]) {
        this.getControl(fieldName, profileFormGroup)?.setValue({ code: 'Y', value: 'Yes' });
      } else {
        this.getControl(fieldName, profileFormGroup)?.setValue({ code: 'N', value: 'No' });
      }
      this.getControl(fieldName, profileFormGroup)?.updateValueAndValidity();
      this.getControl(fieldName, profileFormGroup)?.clearValidators();

    });
  }

  showMoreKatieBeckettProgramModal() {
    this.modalService.openKatieBeckettProgram();
  }

  showExpenseResources() {
    if (this.isRenewBenefits) {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medicareIndSw'),
        this.getValue('extras.helpers.ssiBenefitsSw'),
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hospiceSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.intelDisbSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('data.medicalBillSw'),
        this.getValue('data.kbReferralSw'),
        this.getValue('extras.helpers.expensesIndSw'),
        this.getValue('extras.helpers.assetIndSw')
      ]);
    }
    else {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medicareIndSw'),
        this.getValue('extras.helpers.ssiBenefitsSw'),
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hospiceSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.intelDisbSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('data.medicalBillSw'),
        this.getValue('data.kbReferralSw')
      ]);
    }
  }

  showTransferResources() {
    if (this.isRenewBenefits) {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('extras.helpers.transferredResIndSw')
      ]);
    }
    else {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.ecfSw')
      ]);
    }
  }

  anyDrivingQuestionAnswered() {
    if (this.isRenewBenefits) {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medicareIndSw'),
        this.getValue('extras.helpers.ssiBenefitsSw'),
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hospiceSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.intelDisbSw'),
        this.getValue('extras.helpers.medicalBillsIndSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('data.medicalBillSw'),
        this.getValue('data.kbReferralSw'),
        this.getValue('extras.helpers.expensesIndSw'),
        this.getValue('extras.helpers.assetIndSw'),
      ]);
    }
    else {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medicareIndSw'),
        this.getValue('extras.helpers.ssiBenefitsSw'),
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hospiceSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.intelDisbSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('data.medicalBillSw'),
        this.getValue('data.kbReferralSw')
      ])
    }
  }

  anyDrivingQuestionAnsweredForTransfer() {
    if (this.isRenewBenefits) {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.ecfSw'),
        this.getValue('extras.helpers.transferredResIndSw')
      ]);
    }
    else {
      return any((item) => {
        return item.code === 'Y' && !this.changeMode;
      })([
        this.getValue('extras.helpers.medFacilitySw'),
        this.getValue('extras.helpers.nursingHomeSw'),
        this.getValue('extras.helpers.hcbsSw'),
        this.getValue('extras.helpers.ecfSw')
      ])
    }
  }

  isProfileOpted(fieldName: string) {
    const helpers = this.getControl('extras.helpers');
    const optField = helpers.get(fieldName);
    let isAllNull = true;
    if (this.record && this.record.data && this.record.data.otherBenefitsIndvProfileData) {
      isAllNull = this.record.data.otherBenefitsIndvProfileData.every((item) => !item[fieldName]);
      if (isAllNull) {
        optField.setValue(null);
      } else {
        this.record && this.record.data && this.record.data.otherBenefitsIndvProfileData.find((item) => {
          return item[fieldName] && item[fieldName].code === 'Y';
        }) ? optField.setValue(this.codeYes) : optField.setValue(this.codeNo);
      }
    }
  }

  onProfileDataChange(fieldName: string, name: string) {

    const selectionValue = (fieldName === 'medicalBillSw') ? this.getValue('data.medicalBillSw') : this.getValue(`extras.helpers.${fieldName}`);
    const otherBenefitsIndvProfileData = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
    otherBenefitsIndvProfileData.controls.forEach((profileFormGroup: FormGroup) => {
      if (selectionValue && selectionValue.code === 'N') {
        this.getControl(fieldName, profileFormGroup)?.setValue({ code: 'N', value: 'No' });
        if (fieldName === 'medFacilitySw') {
          this.getControl('hospitalName', profileFormGroup).clearValidators();
          this.getControl('hospitalName', profileFormGroup).updateValueAndValidity();
          this.getControl('medFacilityAdmitDt', profileFormGroup).clearValidators();
          this.getControl('medFacilityAdmitDt', profileFormGroup).updateValueAndValidity();
          this.getControl('medFacilityAdmitDt', profileFormGroup).setValue(null);
          this.getControl('hospitalName', profileFormGroup).setValue(null);
        }
        if (fieldName === 'nursingHomeSw') {
          this.getControl('nursingHomeName', profileFormGroup).clearValidators();
          this.getControl('nursingHomeName', profileFormGroup).updateValueAndValidity();
          this.getControl('nursingHomeName', profileFormGroup).setValue(null);
          this.getControl('nursingHomeAdmitDt', profileFormGroup).clearValidators();
          this.getControl('nursingHomeAdmitDt', profileFormGroup).updateValueAndValidity();
          this.getControl('nursingHomeAdmitDt', profileFormGroup).setValue(null);
        }

        if(fieldName === 'medicalBillSw'){
          this.getControl('medicalBillsIndSw', profileFormGroup).clearValidators();
          this.getControl('medicalBillsIndSw', profileFormGroup).updateValueAndValidity();
          this.getControl('medicalBillsIndSw', profileFormGroup).setValue(null);
        }else{
          this.getControl(fieldName, profileFormGroup).clearValidators();
          this.getControl(fieldName, profileFormGroup).updateValueAndValidity();
        }
        
      } else if (selectionValue && selectionValue.code === 'Y') {
       
          var indivData = (this.getControl(`extras.helpers.${name}`) as FormGroup).controls;
          this.individualTable.forEach(element => {
            if(indivData[element.code]){
              (this.getControl(`extras.helpers.${name}`) as FormGroup).controls[element.code].setValue(null);
              (this.getControl(`extras.helpers.${name}`) as FormGroup).controls[element.code].clearValidators();
              (this.getControl(`extras.helpers.${name}`) as FormGroup).controls[element.code].updateValueAndValidity();
            }
          });

          if(fieldName === 'medicalBillSw'){
            this.getControl('medicalBillsIndSw', profileFormGroup).setValidators([Vs.requiredTrue]);
            this.getControl('medicalBillsIndSw', profileFormGroup).updateValueAndValidity();
          }else{
            this.getControl(fieldName, profileFormGroup).setValidators([Vs.requiredTrue]);
            this.getControl(fieldName, profileFormGroup).updateValueAndValidity();
          }

          if (fieldName === 'brstCervCancerSw' && this.isPresumptiveBcc) {
            this.presetBrstCervCancerFromApplyForCoverage();
          }
                 
             // ((this.getControl('extras.helpers.intelDisbSwOpt') as FormGroup).controls[this.individualTable[0].code] as FormControl).setValue(null);
      } else if (selectionValue == '') {
        if (fieldName === 'medicalBillSw'){
          this.getControl('medicalBillsIndSw', profileFormGroup)?.clearValidators();
          this.getControl('medicalBillsIndSw', profileFormGroup)?.updateValueAndValidity();
          this.getControl('data.medBillsDisableSw').setValue(null);
          this.getControl('medicalBillsIndSw', profileFormGroup)?.setValue(null);
          this.getControl(fieldName, profileFormGroup)?.clearValidators();
          this.getControl(fieldName, profileFormGroup)?.updateValueAndValidity();
          this.getControl(fieldName, profileFormGroup)?.setValue(null);
      }
        else if (fieldName === 'kbReferralSw'){
          this.getControl('data.kbReferralSw').setValue(null);
        }
        else if (fieldName === 'medFacilitySw') {
          this.getControl('hospitalName', profileFormGroup).clearValidators();
          this.getControl('hospitalName', profileFormGroup).updateValueAndValidity();
          this.getControl('medFacilityAdmitDt', profileFormGroup).clearValidators();
          this.getControl('medFacilityAdmitDt', profileFormGroup).updateValueAndValidity();
          this.getControl('medFacilityAdmitDt', profileFormGroup).setValue(null);
          this.getControl('hospitalName', profileFormGroup).setValue(null);
        }
        else if (fieldName === 'nursingHomeSw') {
          this.getControl('nursingHomeName', profileFormGroup).clearValidators();
          this.getControl('nursingHomeName', profileFormGroup).updateValueAndValidity();
          this.getControl('nursingHomeName', profileFormGroup).setValue(null);
          this.getControl('nursingHomeAdmitDt', profileFormGroup).clearValidators();
          this.getControl('nursingHomeAdmitDt', profileFormGroup).updateValueAndValidity();
          this.getControl('nursingHomeAdmitDt', profileFormGroup).setValue(null);
        }
        if(fieldName === 'medicalBillSw'){
          this.getControl('medicalBillsIndSw', profileFormGroup).clearValidators();
          this.getControl('medicalBillsIndSw', profileFormGroup).updateValueAndValidity();
          this.getControl('medicalBillsIndSw', profileFormGroup)?.setValue(null);
        }else{
          this.getControl(fieldName, profileFormGroup).clearValidators();
          this.getControl(fieldName, profileFormGroup).updateValueAndValidity();
          this.getControl(fieldName, profileFormGroup)?.setValue(null);
        }
      }
      var anyOptionSelected = this.anyDrivingQuestionAnswered();
      if (!anyOptionSelected && !this.changeMode && !this.isRenewBenefits) {
        this.getControl('data.assetInd')?.setValue(null);
        this.getControl('data.expensesInd')?.setValue(null);
        this.getControl('data.expenseDisableSw')?.setValue(null);
        this.getControl('data.assetDisableSw')?.setValue(null);
        this.getControl('data.assetIndSw')?.patchValue(null);
        this.getControl('data.expensesIndSw')?.patchValue(null);
        this.getControl('data.assetIndSw')?.setValue(null);
        this.getControl('data.expensesIndSw')?.setValue(null);
        this.getControl('expensesIndSw', profileFormGroup)?.setValue(null);
        this.getControl('assetIndSw', profileFormGroup)?.setValue(null);
        this.getControl('expensesIndSw', profileFormGroup)?.patchValue(null);
        this.getControl('assetIndSw', profileFormGroup)?.patchValue(null);
        this.getControl('data.otherBenefitsIndvProfileData.expensesIndSw')?.setValue(null);
        this.getControl('data.otherBenefitsIndvProfileData.assetIndSw')?.setValue(null);
        this.getControl('extras.helpers.expensesIndSw').setValue(null);
        this.getControl('extras.helpers.assetIndSw').setValue(null);
        this.getControl('assetIndSw', profileFormGroup).clearValidators();
        this.getControl('assetIndSw', profileFormGroup).updateValueAndValidity();
        this.getControl('expensesIndSw', profileFormGroup).clearValidators();
        this.getControl('expensesIndSw', profileFormGroup).updateValueAndValidity();
        this.getControl('data.transferredResInd')?.setValue(null);
        this.getControl('data.transferredResInd')?.clearValidators();
        this.getControl('data.transferredResInd')?.updateValueAndValidity();
        this.getControl('data.transferAssetDisableSw')?.setValue(null);
        this.getControl('data.transferredResIndSw')?.patchValue(null);
        this.getControl('data.transferredResIndSw')?.setValue(null);
        this.getControl('transferredResIndSw', profileFormGroup)?.setValue(null);
        this.getControl('transferredResIndSw', profileFormGroup)?.patchValue(null);
        this.getControl('data.otherBenefitsIndvProfileData.transferredResIndSw')?.setValue(null);
        this.getControl('extras.helpers.transferredResIndSw').setValue(null);
        this.getControl('extras.helpers.transferredResIndSw').clearValidators();
        this.getControl('extras.helpers.transferredResIndSw').updateValueAndValidity();
        this.getControl('transferredResIndSw', profileFormGroup).clearValidators();
        this.getControl('transferredResIndSw', profileFormGroup).updateValueAndValidity();
      }

      var anyOptionSelectedForTransfer = this.anyDrivingQuestionAnsweredForTransfer();

      if (!anyOptionSelectedForTransfer && !this.changeMode && !this.isRenewBenefits) {
        this.getControl('data.transferredResInd')?.setValue(null);
        this.getControl('data.transferredResInd')?.clearValidators();
        this.getControl('data.transferredResInd')?.updateValueAndValidity();
        this.getControl('data.transferAssetDisableSw')?.setValue(null);
        this.getControl('data.transferredResIndSw')?.patchValue(null);
        this.getControl('data.transferredResIndSw')?.setValue(null);
        this.getControl('transferredResIndSw', profileFormGroup)?.setValue(null);
        this.getControl('transferredResIndSw', profileFormGroup)?.patchValue(null);
        this.getControl('data.otherBenefitsIndvProfileData.transferredResIndSw')?.setValue(null);
        this.getControl('extras.helpers.transferredResIndSw').setValue(null);
        this.getControl('extras.helpers.transferredResIndSw').clearValidators();
        this.getControl('extras.helpers.transferredResIndSw').updateValueAndValidity();
        this.getControl('transferredResIndSw', profileFormGroup).clearValidators();
        this.getControl('transferredResIndSw', profileFormGroup).updateValueAndValidity();
      }

      if (!anyOptionSelectedForTransfer && this.isRenewBenefits) {
        this.getControl('data.transferredResInd')?.setValue(null);
        this.getControl('data.transferredResInd')?.clearValidators();
        this.getControl('data.transferredResInd')?.updateValueAndValidity();
      }

      if (anyOptionSelectedForTransfer && !this.changeMode && !this.isPresumptive) {
        this.getControl('data.transferredResInd')?.setValidators(Vs.required);
      }
      if (anyOptionSelectedForTransfer && this.isPresumptive) {
        this.getControl('data.transferredResInd')?.setValue(null);
        this.getControl('data.transferredResInd')?.clearValidators();
        this.getControl('data.transferredResInd')?.updateValueAndValidity();
        this.getControl('data.transferredResIndSw')?.setValidators(Vs.required);
        this.getControl('data.transferredResIndSw')?.updateValueAndValidity();
        this.getControl('extras.helpers.transferredResIndSw')?.setValidators(Vs.required);
        this.getControl('extras.helpers.transferredResIndSw')?.updateValueAndValidity();
        this.getControl('transferredResIndSw', profileFormGroup)?.setValidators(Vs.required);
        // this.getControl('transferredResIndSw', profileFormGroup)?.updateValueAndValidity();
      }
    });
  }

  presetBrstCervCancerFromApplyForCoverage() {
    const brstCervCancerSwOpt = this.getControl('extras.helpers.brstCervCancerSwOpt') as FormGroup;
    if (!brstCervCancerSwOpt || !this.individualsForBcc) return;
    const applyForCoverageYesIds = this.individualsForBcc
      .filter((indv: any) => indv?.applyForCoverage?.code === 'Y')
      .map((indv: any) => indv.identifier);
    const otherBenefitsIndvProfileData = this.getControl('data.otherBenefitsIndvProfileData') as FormArray;
    applyForCoverageYesIds.forEach((id: string) => {
      const control = brstCervCancerSwOpt.controls[id];
      if (!control) return;
      const individual = this.individualsForBcc.find((indv: any) => indv.identifier === id);
      const checkedValue = {
        code: id,
        value: individual ? `${individual.name.fullName}, ${individual.age} ${individual.gender.code}` : id
      };
      if (!control.value) {
        control.setValue(checkedValue, { emitEvent: false });
      }
      otherBenefitsIndvProfileData?.controls.forEach((profileFormGroup: FormGroup) => {
        if (this.getValue('indvId', profileFormGroup) === id) {
          this.getControl('brstCervCancerSw', profileFormGroup)?.setValue({ code: 'Y', value: 'Yes' });
          this.getControl('brstCervCancerSw', profileFormGroup).clearValidators();
          this.getControl('brstCervCancerSw', profileFormGroup).updateValueAndValidity();
        }
      });
    });
    if(applyForCoverageYesIds.length > 0) 
    {
      otherBenefitsIndvProfileData?.controls.forEach((profileFormGroup: FormGroup) => {      
      this.getControl('brstCervCancerSw', profileFormGroup).clearValidators();
      this.getControl('brstCervCancerSw', profileFormGroup).updateValueAndValidity();      
      });
    }
  }

  isMedFacilitySw(profileGroup) {
    return this.getValue('medFacilitySw', profileGroup) && this.getValue('medFacilitySw', profileGroup).code === 'Y';
  }
    isNursingHomeSw(profileGroup) {
    return this.getValue('nursingHomeSw', profileGroup) && this.getValue('nursingHomeSw', profileGroup).code === 'Y';
  }

  isKbReferralSw() {
    let minor = false;
    this.individuals.forEach(indiv => {
      if (indiv.age < 18) {
        minor = true;
      }
    });
    return minor;
  }

  
 onTransfer(val){
  if(val.target.value  !== 'Yes' || val.target.value  !== 'Si' || val.target.value  !== 'No'){
    this.getControl('data.transferredResInd')?.setValidators(Vs.required);
    this.getControl('data.transferredResInd')?.updateValueAndValidity();
  }
 }
}